import { reviews } from '../../../mocks/reviews';

export default function ReviewsSection() {
  return (
    <section className="py-20 px-4">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12 animate-on-scroll opacity-0">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">Отзывы игроков о live-казино</h2>
          <p className="text-gray-400">Реальные впечатления от игры с живыми дилерами</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {reviews.map((review, index) => (
            <div 
              key={review.id} 
              className={`bg-[#242429] rounded-2xl p-8 hover:shadow-2xl hover:shadow-[#d4af37]/20 transition-all duration-300 animate-on-scroll opacity-0 ${index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'}`}
              style={{ animationDelay: `${index * 100}ms` }}
            >
              <div className="flex items-start gap-6 mb-4">
                <div className="flex-shrink-0">
                  <img 
                    src={review.avatar} 
                    alt={review.name} 
                    className="w-20 h-20 rounded-full object-cover border-4 border-[#d4af37]"
                  />
                  <div className="flex items-center justify-center gap-1 mt-2">
                    {[...Array(5)].map((_, i) => (
                      <i key={i} className={`${i < review.rating ? 'ri-star-fill text-[#d4af37]' : 'ri-star-line text-gray-600'} text-sm`}></i>
                    ))}
                  </div>
                </div>
                
                <div className="flex-1">
                  <div className="flex items-start justify-between mb-3">
                    <div>
                      <h4 className="text-xl font-bold mb-1">{review.name}</h4>
                      <span className="text-sm text-[#d4af37]">{review.casino}</span>
                    </div>
                  </div>
                  
                  <div className="relative">
                    <i className="ri-double-quotes-l text-4xl text-[#d4af37] opacity-20 absolute -top-2 -left-2"></i>
                    <p className="text-gray-300 italic leading-relaxed pl-6">{review.text}</p>
                  </div>
                  
                  <div className="mt-4 text-sm text-gray-500">{review.date}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}